import(/* webpackMode: "eager" */ "/vercel/path0/nextjs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/nextjs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/components/Footer/ServerTimeDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/components/Footer/SocialIcons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/components/Footer/SubscribeWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/templates/auction-item/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/templates/maintenance/index.tsx");
